module.exports = __webpack_public_path__ + "static/media/ruzencova-pout-2025-program.2ecd8516.jpg";